
import "./UpperText.css"

const UpperText = () =>{
    return(
        <div id="texts">
            <div id="heading">“Skill Development”</div>
            <div id="heading-under-text"> We have more than 300 courses for you to learn and get hired.</div>
            <button id="upper-section-button">Explore Course</button>
        </div>
    )
}

export default UpperText;